import React, { useCallback, useEffect, useState } from 'react';
import { Form, Button, Spin, Alert, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import apiCalls from 'src/api/apiCalls';
const permissionsToShow = ["CardsManageService"]
const ManagePermissions = () => {
    const navigate = useNavigate()
    const [permissionErrorMessage, setPermissionErrorMessage] = useState(null);
    const [isPermissionBtnLoader, setIsPermissionBtnLoader] = useState(false);
    const [permissionLoader, setPermissionLoader] = useState(false);
    const [getPermissionData, setGetPermissionData] = useState([]);
    const [selectPermission, setSelectPermission] = useState(null);
    const [permissionSave, setPermissionSave] = useState([]);
    const [grantAllPermissions, setGrantAllPermissions] = useState(false);
    const { id, roleName } = useParams()
    useEffect(() => {
        permissionGet();
    }, []);
    const permissionGet = async () => {
        setPermissionLoader(true);
        setPermissionErrorMessage(null);
        if (id) {
            try {
                let response = await apiCalls.rolesPerissionGet(roleName)
                if (response?.ok) {
                    setPermissionLoader(false);
                    const filteredGroups = response?.data?.groups?.filter(group =>
                        permissionsToShow.includes(group?.name)
                    );
                    setGetPermissionData({
                        entityDisplayName: response?.data?.entityDisplayName,
                        groups: filteredGroups,
                    });
                    const isAllGranted = filteredGroups[0].permissions.every(permission => permission.isGranted === true);
                    handleIsAllGranted(isAllGranted);
                    setSelectPermission(filteredGroups[0]);
                    setPermissionSave({
                        entityDisplayName: response?.data?.entityDisplayName,
                        groups: filteredGroups,
                    });
                } else {
                    setPermissionLoader(false);
                    setPermissionErrorMessage(apiCalls.isErrorDispaly(response));
                }
            } catch (error) {
                setPermissionLoader(false);
                setPermissionErrorMessage(apiCalls.isErrorDispaly(error));
            }
        }
    };
    const handleIsAllGranted = (isAllGranted) => {
        setGrantAllPermissions(isAllGranted);
    };
    const compareAndFilterGranted = (obj1, obj2) => {
        let differences = [];
        for (let i = 0; i < Math.min(obj1.length, obj2.length); i++) {
            for (let j = 0; j < Math.min(obj1[i].permissions.length, obj2[i].permissions.length); j++) {
                let permission1 = obj1[i].permissions[j];
                let permission2 = obj2[i].permissions[j];
                if (permission1.isGranted !== permission2.isGranted) {
                    differences.push({ name: permission1.name, isGranted: permission2.isGranted });
                }
            }
        }
        return differences || [];
    };
    const handleClose = useCallback(() => {
        navigate(`/settings/roles`)
    }, [navigate])
    const rolesPermissionSave = useCallback(async () => {
        setPermissionErrorMessage(null);
        setIsPermissionBtnLoader(true);
        const compareList = compareAndFilterGranted(permissionSave?.groups, getPermissionData?.groups);
        if (compareList.length > 0) {
            try {
                let response = await apiCalls.rolesPerissionSave(roleName, { permissions: compareList });
                if (response.ok) {
                    navigate(`/settings/roles`);
                    setIsPermissionBtnLoader(false);
                    setPermissionErrorMessage(null);
                    message.success({
                        content: "Role Permissions Saved Successfully.",
                        className: "custom-msg",
                        duration: 3,
                    });
                } else {
                    setPermissionErrorMessage(apiCalls.isErrorDispaly(response));
                    setIsPermissionBtnLoader(false);
                }
            } catch (error) {
                setPermissionErrorMessage(apiCalls.isErrorDispaly(error));
                setIsPermissionBtnLoader(false);
            }
        } else {
            handleClose();
        }
    }, [permissionSave, getPermissionData, roleName, apiCalls, navigate, handleClose]);
    const clearErrors = useCallback(() => {
        setPermissionErrorMessage(null);
    }, [])
    const getSelectedPermissionsList = () => {
        let selectPermision = getPermissionData?.groups?.filter(item => item?.displayName === selectPermission?.displayName)[0];
        return selectPermision?.permissions || [];
    };
    const updateMainPermission = (flag, permissionsObj) => {
        const isMatching = (permission) => {
            if (permissionsObj?.name) {
                return permissionsObj.name === permission.name || permissionsObj.name === permission?.parentName;
            }
            return (selectPermission?.permissions || []).some(
                (selectPerm) =>
                    selectPerm.name === permission.name ||
                    (permission.name === selectPerm?.parentName && flag)
            );
        };
        const updatePermission = (permission) => ({
            ...permission,
            isGranted: isMatching(permission) ? flag : permission.isGranted,
        });
        const updatedGroupsData = getPermissionData?.groups.map((group) => ({
            ...group,
            permissions: group.permissions.map(updatePermission),
        }));
        setGetPermissionData({ ...getPermissionData, groups: updatedGroupsData });
    };
    const handleSelectRole = (e, selectPermissionData, type,) => {
        let check = e.target.checked;
        if (type === "Select all") {
            const updatedData = selectPermission?.permissions.map((permissions) => ({
                ...permissions,
                isGranted: check,
            }));
            if (!check) {
                setGrantAllPermissions(check)
            }
            setSelectPermission({ ...selectPermission, permissions: updatedData })
            updateMainPermission(check, null)
        } else if (type === "Grant all Permissions") {
            let updatedGroupsData = getPermissionData?.groups;
            const updatedObject = updatedGroupsData?.map(category => ({
                ...category,
                permissions: category?.permissions?.map(permission => ({
                    ...permission,
                    isGranted: check,
                })),
            }));
            setGetPermissionData({ ...getPermissionData, groups: updatedObject })
            setGrantAllPermissions(check)
        } else if (type === "Sub permissions" || type === "main permissions") {
            const updatedData = selectPermission?.permissions.map((permission) => (
                (permission.name === selectPermissionData.name || (permission.name === selectPermissionData.parentName && check))
                    ? { ...permission, isGranted: check }
                    : permission
            ));
            const isAllGranted = updatedData.every(permission => permission.isGranted === true);
            handleIsAllGranted(isAllGranted);
            setSelectPermission({ ...selectPermission, permissions: updatedData })
            updateMainPermission(check, selectPermissionData);
        }
    }
    return (
        <div className=''>
            <>
                {permissionLoader && <div className='flex justify-center items-center h-screen'><Spin /></div>}
                {permissionErrorMessage && (
                    <Alert message="Error" description={permissionErrorMessage} type="error" showIcon closable onClose={clearErrors} />
                )}
                {!permissionLoader && (
                    <div className='manage-permission'>
                        <>
                            <Form>
                                <div className='grid md:grid-cols-3 gap-8 rounded-5'>
                                    <div className=''>
                                        <div className='flex items-center space-x-2 border-b border-StrokeColor pb-2'>
                                            <label htmlFor className="text-center custom-checkbox c-pointer cust-check-outline">
                                                <input
                                                    type="checkbox"
                                                    value={grantAllPermissions}
                                                    checked={grantAllPermissions}
                                                    onChange={(e) => handleSelectRole(e, null, "Grant all Permissions")}
                                                    className="c-pointer"
                                                />
                                                <span></span>
                                            </label>
                                            <span className='text-subTextColor text-lg font-semibold'>Grant all Permissions</span>
                                        </div>
                                    </div>
                                    <div className='md:col-span-2 flex-1'>
                                        <div className=''>
                                            {getSelectedPermissionsList()?.map((item) => (<>
                                                {item?.parentName == null &&
                                                    <div className='flex items-center gap-2'>
                                                        <label htmlFor className="text-center custom-checkbox cursor-pointer cust-check-outline">
                                                            <input
                                                                type="checkbox"
                                                                value={item?.isGranted}
                                                                checked={item?.isGranted}
                                                                onChange={(e) => handleSelectRole(e, item, "main permissions")}
                                                                className="c-pointer"
                                                            />
                                                            <span></span>
                                                        </label>
                                                        <h4 className='text-subTextColor text-base font-medium'>{item?.displayName}</h4>
                                                    </div>
                                                }
                                                {item?.parentName &&
                                                    <div className='flex items-center ms-6 gap-2 mt-0.5 mb-1'>
                                                        <label htmlFor className="text-center custom-checkbox cust-check-outline">
                                                            <input
                                                                value={item?.isGranted}
                                                                checked={item?.isGranted}
                                                                type="checkbox"
                                                                onChange={(e) => handleSelectRole(e, item, "Sub permissions")}
                                                                className="c-pointer"
                                                            />
                                                            <span></span>
                                                        </label>
                                                        <p className='text-paraColor text-base  font-normal'>{item?.displayName}</p>
                                                    </div>
                                                }
                                            </>))}
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-5 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                                    <Button className='cancel-btn !py-5' key="back" onClick={handleClose}>Cancel</Button>
                                    <Button className='primary-btn' type="primary" onClick={rolesPermissionSave} htmlType="submit" loading={isPermissionBtnLoader}>Save</Button>
                                </div>
                            </Form>
                        </>
                    </div>
                )}
            </>
        </div>
    );
};
export default ManagePermissions;
